<template>
  <div class="login-page-wrapper">
      <!-- 控制一下宽度，上面留一定的空间 -->
      <v-container class='d-flex justify-center mt-10'>
        <v-form ref="form"   style="width: 300px;">
          <v-card-title class="justify-center">登录剪辑系统</v-card-title>
          

          <v-text-field
            v-model="phoneNumber"
            :rules="phoneRules"
            label="手机号"
            required
          ></v-text-field>

          <v-text-field
            v-model="password"
            :rules="passwordRules"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="输入密码"
            hint="至少3个字符"
            counter
            @click:append="show1 = !show1"
          ></v-text-field>

          <div class="d-flex justify-space-between align-center mt-4">
            <v-btn color="success" class="mr-4" @click="submitForm">
              登录
            </v-btn>
            <v-btn variant="text" size="small" color="primary" @click="showGuideDialog = true">
              如何获取密码？
            </v-btn>
          </div>
        </v-form>
      </v-container>

      <v-dialog v-model="showGuideDialog" max-width="400">
        <v-card>
          <v-card-title class="headline text-center justify-center pt-4">如何获取/修改密码？</v-card-title>
          <v-card-text class="text-center pb-2">
            <p class="mb-4 text-grey text-body-2">
              初次使用系统或忘记密码？<br/>
              请使用微信扫码进入小程序，在【我的】页面点击【修改密码】来设置您的登录密码。
            </p>
            <div class="d-flex justify-center mb-2 mx-auto" style="height: 200px; width: 200px;">
               <v-img :src="myQrcodeImg" max-height="200" max-width="200" contain></v-img>
            </div>
            <v-btn color="primary" block @click="showGuideDialog = false" class="mt-4 mb-2" rounded>知道了</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showVipDialog" max-width="400">
        <v-card>
          <v-card-title class="headline text-center justify-center">扫码继续</v-card-title>
          <v-card-text class="text-center">
            <p class="mb-4 text-grey">非VIP用户禁止登录，请关注公众号或升级VIP</p>
            <div class="d-flex justify-center mb-4" style="height: 200px; width: 200px; margin: 0 auto; background: #fff; border-radius: 8px;">
               <v-img v-if="qrCodeUrl" :src="qrCodeUrl" max-height="200" max-width="200" contain></v-img>
               <div v-else class="d-flex align-center justify-center fill-height flex-column">
                  <div v-if="qrError" class="d-flex flex-column align-center">
                      <v-icon color="error" size="40">mdi-alert-circle</v-icon>
                      <span class="text-caption mt-2 text-error">加载二维码失败</span>
                      <v-btn variant="text" size="small" color="primary" @click="generateQRCode" class="mt-2">重试</v-btn>
                  </div>
                  <template v-else>
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      <span class="text-caption mt-2">加载二维码中...</span>
                  </template>
               </div>
            </div>
            <div class="d-flex flex-column gap-2">
                <!-- <v-btn color="primary" block @click="handleTrial" class="mb-2" rounded>免费试用</v-btn> -->
                <div class="text-caption text-grey">请使用微信扫码关注“数读2046实验室”</div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import { BASE_URL } from '@/config';
  import myQrcodeImg from '@/assets/my-qrcode.png';

  export default {
    data: () => ({
      myQrcodeImg,
      showGuideDialog: false,
      show1: false,
      phoneNumber: '',
      password: '',
      phoneRules: [
        v => !!v || '手机号未填',
        v => v.length == 11 || '手机号长度为11位',
        v => /^\d{11}$/.test(v) || '手机号格式不正确，请输入有效的11位手机号码'
      ],
      passwordRules: [
        v => !!v || '密码未填',
        v => v.length >= 3 || '密码长度至少3位',
      ],
      showVipDialog: false,
      qrCodeUrl: '',
      isGeneratingQR: false,
      qrError: false,
    }),    

    mounted() {
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        if (!token || !userStr) {
          return;
        }
        try {
          JSON.parse(userStr);
        } catch (e) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          console.error('Error parsing user info', e);
        }
    },

    methods: {
      async generateQRCode() {
         if(this.qrCodeUrl || this.isGeneratingQR) return;
         this.isGeneratingQR = true;
         this.qrError = false;
         try {
           const res = await axios.get(BASE_URL + 'user/service_account_qrcode', { timeout: 10000 });
           // Axios plugin returns data directly if code=200
           if (res && res.ticket) {
               this.qrCodeUrl = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${encodeURIComponent(res.ticket)}`;
           }
         } catch (err) {
           console.error('生成二维码失败', err);
           this.qrError = true;
         } finally {
           this.isGeneratingQR = false;
         }
      },

      async handleTrial() {
          try {
              // payment endpoints are usually at root, not under /clipper/
              // Assuming BASE_URL ends with /clipper/
              const baseUrl = BASE_URL.replace('clipper/', '');
              await axios.post(baseUrl + 'payment/activate_trial', {});
              this.$store.commit('snackbar/show', { text: '试用领取成功', color: 'success' });
              
              // Refresh user info or just redirect
              // Since we already have token, we can proceed
              this.showVipDialog = false;
              this.onLoginSuccess();
          } catch (e) {
              console.error(e);
              // Error is handled by global interceptor or here
          }
      },

      onLoginSuccess() {
            // 判断上一个页面是否是本系统的页面，如果是，则回到上一个页面
            // 如果不是，则跳转到主页(由HomePage根据权限决定去哪个子页面)
            const from = this.$route.query.from
            if (from) {
              //判断是否是同一个域名下的页面
              const fromUrl = new URL(from)
              const currentUrl = new URL(window.location.href)
              if (fromUrl.hostname == currentUrl.hostname) {
                this.$router.go(-1)
                return
              }
            }

            this.$router.push('/clipper/')
      },

      async submitForm () {
        const { valid } = await this.$refs.form.validate()
        if (valid) {
          this.$store.dispatch('login', {phoneNumber: this.phoneNumber, password: this.password})
          .then(() => {
            this.onLoginSuccess();
          })
          .catch((error) => {
            // Check for Not VIP restriction
            if (error && error.code === 403001 && error.data) {
                // Store token even if rejected (it is returned in data)
                // The store login action rejected, so state.user might not be set?
                // Wait, if login action rejects, it doesn't commit user.
                // We need to commit user manually here if we want to allow "trial" which requires token.
                
                // error.data contains: { access_token, user, ... }
                const data = error.data;
                const token = data.access_token;
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(data.user));
                this.$store.commit('setUser', data.user);
                
                this.showVipDialog = true;
                this.generateQRCode();
                return;
            }

            // 登录失败的处理已经在store中完成（显示alert）
            console.error('登录失败:', error)
          })          
        }
      },
    }
  }
</script>
